import { initLogin, usernameLogin, changePassword, submitPhone, submitPin, logout } from './public/auth.api';
import { getTenant } from './public/tenant.api';
import { getUserProfile, setUserStatus, updateProfileImage, removeProfileImage } from './public/profile.api';
import { getNewsList, getNews, downloadNewsAttachment } from './public/news.api';
import { getPolls, getPoll, getUserPollAnswer, submitPollAnswer } from './public/poll.api';
import { getEvents, getEvent, enrollEvent, cancelEventEnrollment, getEventEnrollment } from './public/events.api';
import { getFeed } from './public/feed.api';
import { getResources, getResource, download as downloadResource } from './public/resources.api';
import { getPeople, searchPersons } from './public/people.api';
import { getBenefits } from './public/benefits.api';
import { getFaq } from './public/faq.api';
import { getPages, getPage, downloadPageAttachment } from './public/pages.api';
import { getPiiriArticles, getPiiriArticle } from './public/piiri-articles.api';
import { getFeedbackPolicy, getFeedbackCategories, saveFeedback, getMyFeedbacks, getMyFeedback, saveMyFeedbackmessage, deleteFeedbackAttachment, saveFeedbackAttachment } from './public/feedback.api';
import { getChannels, getManagedChannels, getChannel, getChannelRooms, getChannelRoom, getChannelRoomForUser, authenticateChatRoom, deleteChatMessage } from './public/chat.api';
import { getWallpapers } from './public/wallpapers.api';


const api = {

    // Auth
    initLogin,
    usernameLogin,
    submitPhone,
    submitPin,
    logout,
    changePassword,

    // Feed
    getFeed,

    // Tenant
    getTenant,

    // News
    getNewsList,
    getNews,
    downloadNewsAttachment,

    // User profile
    getUserProfile,
    setUserStatus,
    updateProfileImage,
    removeProfileImage,

    // Polls
    getPolls,
    getPoll,
    getUserPollAnswer,
    submitPollAnswer,

    // Events
    getEvents,
    getEvent,
    getEventEnrollment,
    enrollEvent,
    cancelEventEnrollment,

    // Resources
    getResources,
    getResource,
    downloadResource,

    // People
    getPeople,
    searchPersons,

    // Benefits
    getBenefits,

    // Faq
    getFaq,

    // Pages
    getPages,
    getPage,
    downloadPageAttachment,

    // Wallpapers
    getWallpapers,

    // Articles
    getPiiriArticles,
    getPiiriArticle,

    // Feedback 
    getFeedbackCategories,
    getFeedbackPolicy,
    saveFeedback,
    getMyFeedback,
    getMyFeedbacks,
    saveMyFeedbackmessage,
    saveFeedbackAttachment,
    deleteFeedbackAttachment,

    // Chat
    getChannels,
    getManagedChannels,
    getChannel,
    getChannelRooms,
    getChannelRoom,
    getChannelRoomForUser,
    authenticateChatRoom,
    deleteChatMessage
}

export default api;